"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _TitleCollectionView = _interopRequireDefault(require("../../media/TitleCollectionView"));

var _collection_highlight = _interopRequireDefault(require("../templates/collection_highlight.html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CollectionHighlight =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(CollectionHighlight, _Backbone$View);

  _createClass(CollectionHighlight, [{
    key: "viewAttributes",
    value: function viewAttributes(collection) {
      var classes = [];

      if (this.isHero) {
        classes.push("large-block-grid-".concat(collection.length));
      } else {
        classes.push("large-block-grid-6");
      }

      if (collection.length <= 2) {
        classes.push("small-block-grid-".concat(collection.length));
      }

      if (collection.length >= 3) {
        classes.push("small-block-grid-2 medium-block-grid-3");
      }

      return {
        "class": "titleContainer ".concat(classes.join(' '))
      };
    }
  }]);

  function CollectionHighlight(_ref) {
    var _this;

    var bus = _ref.bus,
        room = _ref.room,
        _ref$isHero = _ref.isHero,
        isHero = _ref$isHero === void 0 ? false : _ref$isHero;

    _classCallCheck(this, CollectionHighlight);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CollectionHighlight).apply(this, arguments));
    _this.template = _collection_highlight["default"];
    _this.bus = bus;
    _this.room = room;
    _this.collection = _this.model.titleCollection;
    _this.isHero = isHero;

    _this.render();

    return _this;
  }

  _createClass(CollectionHighlight, [{
    key: "render",
    value: function render() {
      var $view = $(this.template(_.extend({}, this.model.attributes, {
        room: this.room,
        seeAllUrl: this.seeAllUrl
      })));
      this.titleCollectionView && this.titleCollectionView.remove();
      this.titleCollectionView = new _TitleCollectionView["default"]({
        el: $view.find('.titleContainer'),
        bus: this.bus,
        attributes: this.viewAttributes(this.collection),
        collection: this.collection,
        coverWidths: {
          mobile: 145,
          tablet: 160,
          desktop: 190
        },
        isInHero: this.isHero,
        context: {
          collectionDefinition: this.model,
          room: this.room
        }
      }); // ref: LHTNG-1970 - hiding the last two elements so we can remove the overflow hidden on the parent container

      $view.find('.Item').each(function (i, el) {
        if (i > 3) {
          $(el).addClass('show-for-medium-up');
        }
      });
      this.$el.empty().append($view);

      if (this.isHero) {
        this.makeHero();
      }

      return this;
    }
  }, {
    key: "makeHero",
    value: function makeHero() {
      this.isHero = true;
      this.$el.find('.collection-container').addClass('Hero');
      this.$el.find('.icon-forward-arrow').remove();
      var description = this.model.attributes.description;

      if (description) {
        this.$el.find('.collectionTitle').after("<p class=\"Hero-collectionDescription\">".concat(description, "</p>"));
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      this.titleCollectionView && this.titleCollectionView.remove();

      _get(_getPrototypeOf(CollectionHighlight.prototype), "remove", this).call(this);
    }
  }, {
    key: "toggleTitleVisibility",
    value: function toggleTitleVisibility(isVisible) {
      var title = this.$el.find('.collectionTitle');
      isVisible ? title.removeClass('invisible') : title.addClass('invisible');
    }
  }, {
    key: "seeAllUrl",
    get: function get() {
      var collectionId = this.model.get('id');
      return collectionId ? window.url(window.routes.collectionById, {
        collectionId: collectionId
      }) : window.url(window.routes.youMayLikeCollection);
    }
  }, {
    key: "desiredTitleCount",
    get: function get() {
      return 6;
    }
  }]);

  return CollectionHighlight;
}(Backbone.View);

exports["default"] = CollectionHighlight;